import { mxCylinder, mxPoint, mxConnectionConstraint } from "../utils/graph/mxModule";

function noConnectionShape() {}

noConnectionShape.prototype = new mxCylinder();
noConnectionShape.prototype.constructor = noConnectionShape;

noConnectionShape.config = {
  width: 70,
  height: 25,
  style: (fontColor) =>
    `shape=no-conn;labelPosition=top;verticalLabelPosition=top;align=right;verticalAlign=top;fontColor=${fontColor};spacingTop=-10;fontSize=10`,
  ports: [
    { name: "no-conn", label: "", x: 0, y: 0.5 },
  ],
};

noConnectionShape.prototype.paintVertexShape = function (c, x, y, w, h) {
  // Styles
  c.setStrokeColor("orange");
  c.setFillColor("white");
  c.setStrokeWidth(1);

  // --- Rectangle occupying right half (full height) ---
  const rectX = x + (w - w/3);
  const rectY = y;
  const rectW = w / 3;
  const rectH = h;

  c.begin();
  c.rect(rectX, rectY, rectW, rectH);
  c.fillAndStroke();

  // --- Stroke coming in from left center ---
  c.begin();
  c.moveTo(x, y + h / 2);       // start at left middle
  c.lineTo(rectX, y + h / 2);   // connect to rectangle’s left edge middle
  c.stroke();

  // --- Criss cross (X) inside rectangle ---
  c.begin();
  // top-left → bottom-right
  c.moveTo(rectX, rectY);
  c.lineTo(rectX + rectW, rectY + rectH);

  // top-right → bottom-left
  c.moveTo(rectX + rectW, rectY);
  c.lineTo(rectX, rectY + rectH);

  c.stroke();
};

export default noConnectionShape;
